import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import InfoProvider from "./context/InfoContext";
import ScrollToTop from "./Components/Scroll/ScrollTop";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <ScrollToTop />
      <InfoProvider>
        <App />
      </InfoProvider>
    </BrowserRouter>
  </React.StrictMode>
);
